<footer id="contact" class="site-footer">
  <div class="footer-brand">
    <img src="/oWekDykQCw8dxeFWx7rBnaWkDAQ_4.png" alt="Pavillion Properties" />
    <p>Property development for modern Nairobi living, from first viewing to key handover.</p>
    <button class="footer-cta" type="button" (click)="inquiryRequested.emit('')">
      Inquire now
    </button>
  </div>

  <div class="footer-columns">
    <div>
      <h2>Explore</h2>
      <button type="button" (click)="pageSelected.emit('about')">About us</button>
      <button type="button" (click)="pageSelected.emit('developments')">Developments</button>
      <button type="button" (click)="homeSectionSelected.emit('process')">Buying process</button>
      <button type="button" (click)="pageSelected.emit('insights')">News &amp; insights</button>
      <button type="button" (click)="pageSelected.emit('content')">Content</button>
    </div>
    <div>
      <h2>Developments</h2>
      @if (projects.length) {
        @for (project of projects; track project.slug) {
          <button type="button" (click)="inquiryRequested.emit(project.name)">
            {{ project.name }}
          </button>
        }
      } @else {
        <button type="button" (click)="pageSelected.emit('developments')">View properties</button>
      }
    </div>
    <div>
      <h2>Contact</h2>
      <p>Nairobi, Kenya</p>
      <p>Mon-Fri / 9:00 AM-5:00 PM</p>
      <a href="tel:+254700000000">+254 700 000 000</a>
    </div>
    <div>
      <h2>Legal</h2>
      <button type="button" (click)="pageSelected.emit('privacy-policy')">Privacy Policy</button>
      <button type="button" (click)="pageSelected.emit('terms')">Terms &amp; Conditions</button>
    </div>
  </div>

  <div class="footer-bottom">
    <span>© 2026 Pavillion Properties</span>
    <a class="powered-by" href="https://preview.acacia.ke" target="_blank" rel="noreferrer">
      <span>Powered by</span>
      <img src="https://preview.acacia.ke/logo/karim_logo.webp" alt="Karim" />
    </a>
  </div>
</footer>
